module.exports = __webpack_public_path__ + "img/genetic.22bc02e2.gif";